import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { removeUser, setUser } from '../reducers/user.reducer';
import authService from '../services/auth.service';

const AuthGuard = ({ component }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();

  const checkToken = useCallback(async () => {
    try {
      const user = await authService.profile();
      if (!user) {
        dispatch(removeUser());
        navigate(`/login`);
      }
      dispatch(
        setUser(user)
      );
      setStatus(true);
      return;
    } catch (error) {
      dispatch(removeUser());
      navigate(`/login`);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    checkToken();
  }, [checkToken]);

  return status ? <>{component}</> : <></>;
};

AuthGuard.propTypes = {
  component: PropTypes.node,
};

export default AuthGuard;
